export default {
    routerName: '部门管理',
    dept: {
        searchName: '检索条件',
        name: '部门名',
        leader: '负责人',
        mobile: '手机号',
        email: '邮箱',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
    },
    table: {
        id: 'ID',
        name: '部门',
        sortOrder: '排序',
        leader: '负责人',
        createBy: '创建者',
        createTime: '创建时间',
        status: '状态',
    },
};
